import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {debounceTime, distinctUntilChanged, filter, map, pluck} from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit {
  @Output() searchValue: EventEmitter<string> = new EventEmitter<string>();
  @Input() set searchStr(str: string) {
    this.search.setValue({searchInput: str});
  }
  @Input() placeholder = '';
  @Input() minCharactersLength = 3;
  @Input() maxLength?: number;
  @Input() set disabled(condition: boolean ) {
    this.isDisabled = condition;
    if (condition) this.search.controls.searchInput.disable({emitEvent: false});
    else this.search.controls.searchInput.enable({emitEvent: false});
  }
  public isDisabled = false;
  public search = new UntypedFormGroup({
    searchInput: new UntypedFormControl('')
  });

  constructor(
  ) { }

  ngOnInit(): void {
    this.searchSubscribe();
  }

  get hasSearchValue(): boolean {
    return Boolean(this.search.controls.searchInput.value);
  }

  public clearSearch(): void {
    this.search.controls.searchInput.setValue('');
  }

  private isSearchEnabled(value: string): boolean {
    return value.length >= this.minCharactersLength || !value.length
  }

  private searchSubscribe(): void {
    this.search.valueChanges
      .pipe(
        untilDestroyed(this),
        pluck('searchInput'),
        debounceTime(500),
        map(val => val ? val.trim() : val),
        filter((val) => Boolean(this.isSearchEnabled(val))),
        distinctUntilChanged(),
      ).subscribe( str => this.searchValue.emit(str));
  }

}
